<template>
  <ag-table
    @selectRows="handleSelectionChange"
    v-loading="props.loading"
    element-loading-text="Loading..."
    :element-loading-spinner="svg"
    element-loading-svg-view-box="-10, -10, 50, 50"
    :size="props.size"
    :hideCheckBox="props.hideCheckBox"
    :enableBoxSelect="props.enableBoxSelect"
    v-bind="agGridOptions"
    :showRightConfig="showRightConfig"
    class="ag-table"
  ></ag-table>
</template>

<script lang="ts" setup>
import { defineEmits, defineProps, withDefaults, reactive, watch } from "vue";
const emits = defineEmits(["update:multipleSelection", "rowClick"]);
const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

interface PropType {
  tableItem: Array<Record<string, any>>;
  tableData: Record<string, any>[];
  height?: string;
  tooltip?: boolean;
  multipleSelection?: Record<string, any>[];
  loading?: boolean;
  showTips?: boolean;
  showHeader?: boolean;
  size?: string;
  hideCheckBox?:boolean;
  showRightConfig?: boolean;
  enableBoxSelect?: boolean;
}

const props = withDefaults(defineProps<PropType>(), {
  tableItem: () => [],
  tableData: () => [],
  height: 320 / 192 + "rem",
  multipleSelection: () => [],
  loading: false,
  showHeader: true,
  size: "default",
  hideCheckBox: true,
  showRightConfig: false,
  enableBoxSelect: true,
});

watch(
  () => props.tableData,
  val => {
    agGridOptions.rowData = val;
  }
);

const getCols = list => {
  return list.map(o => {
    const obj = { ...o };
    if ("label" in obj) {
      obj["headerName"] = obj.label;
      delete obj.label;
    }
    if ("prop" in obj) {
      obj["field"] = obj.prop;
      delete obj.prop;
    }
    return obj;
  });
};

const agGridOptions = reactive({
  columnDefs: getCols(props.tableItem),
  rowData: props.tableData
});

const handleSelectionChange = (e: Record<string, any>[]): void => {
  emits("update:multipleSelection", e);
};

const rowClick = (
  row: Record<string, any>,
  column: Record<string, any>
): void => {
  emits("rowClick", row, column);
};
</script>

<style lang="scss" scoped>
.ag-table {
  height: 100%;
  :deep(.ag-theme-balham) {
    // height: auto !important;
  }
}
</style>
